import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadPrinterSetupStatus: 'idle',
    loadPrinterSetupError: undefined as any,
    savePrinterSetupStatus: 'idle',
    savePrinterSetupError: undefined as any,

    printerSetupList: [] as any[],
    defaultValues: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadPrinterSetup = createAsyncThunk('printerSetupSlice/loadPrinterSetup', async ({ parentModel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvcprinter/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadPrinterSetupStatus } = getState().printerSetupSlice
        return loadPrinterSetupStatus !== 'pending'
    }
})

export const savePrinterSetup = createAsyncThunk('printerSetupSlice/savePrinterSetup', async ({ printerSetup }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ixprnsrvcprinter/`,
        prepareData(printerSetup),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { savePrinterSetupStatus } = getState().printerSetupSlice
        return savePrinterSetupStatus !== 'pending'
    }
})

const PrinterSetupSlice = createSlice({
    name: 'printerSetupSlice',
    initialState,
    reducers: {
        resetloadPrinterSetup: (state) => {
            state.defaultValues = undefined
            state.loadPrinterSetupError = undefined
        },
        resetloadPrinterSetupError: (state) => {
            state.loadPrinterSetupError = undefined
        },
        resetsavePrinterSetupError: (state) => {
            state.savePrinterSetupError = undefined
        },
        removeFromPrinterSetupListById: (state, action) => {
            state.printerSetupList = state.printerSetupList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromPrinterSetupListByIds: (state, action) => {
            state.printerSetupList = state.printerSetupList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.printerSetupList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadPrinterSetupStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.printerSetupList = []
            state.loadPrinterSetupStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(loadPrinterSetup.pending, (state) => {
            state.loadPrinterSetupStatus = 'pending'
            state.loadPrinterSetupError = undefined
        })
        builder.addCase(loadPrinterSetup.fulfilled, (state, action) => {
            state.loadPrinterSetupStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadPrinterSetup.rejected, (state, action) => {
            state.loadPrinterSetupStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadPrinterSetupError = action.error.message
            } else {
                state.loadPrinterSetupError = action.payload
            }
        })

        builder.addCase(savePrinterSetup.pending, (state) => {
            state.savePrinterSetupStatus = 'pending'
            state.savePrinterSetupError = undefined
        })
        builder.addCase(savePrinterSetup.fulfilled, (state, action) => {
            state.savePrinterSetupStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.printerSetupList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.printerSetupList.push(newItem) }
                else { state.printerSetupList[i] = { ...state.printerSetupList[i], ...newItem } }
            }
        })
        builder.addCase(savePrinterSetup.rejected, (state, action) => {
            state.savePrinterSetupStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.savePrinterSetupError = action.error.message
            } else {
                state.savePrinterSetupError = action.payload
            }
        })

    }
})

export const {
    resetloadPrinterSetup,
    resetloadPrinterSetupError,
    resetsavePrinterSetupError,
    removeFromPrinterSetupListById,
    removeFromPrinterSetupListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = PrinterSetupSlice.actions
export default PrinterSetupSlice.reducer
